<mat-card class="px-0 py-0">
  <form [formGroup]="form">
    <div class="row no-gutters align-items-center">
      <div class="d-flex flex-row col-xl-4 pl-3 py-0 ml-1 my-xl-0 my-3 date-range align-items-center">
        <span class="mr-4">Order Fill</span>
        <span class="font-weight-bold">{{ dateDescription }}</span>
        <div class="m-auto pl-3 ml-1">
          <mat-divider class="mt-1 mb-4 d-none d-xl-block" [vertical]="true"></mat-divider>
        </div>
      </div>
      <div class="col-xl-7 px-3 pt-2 mx-1 mb-xl-0 mb-md-2 mb-sm-2 border-top">
        <div class="row d-flex flex-grow flex-grow-1 mt-2">
          <div class="col-md-3 pb-2">
            <mat-form-field class="w-100" appearance="outline">
              <mat-label>Date Range</mat-label>
              <mat-select aria-label="Date Range" formControlName="dateRange" disableOptionCentering
                          (selectionChange)="updateInterval($event.value)">
                <mat-option *ngFor="let interval of intervals" [value]="interval">{{ interval }}</mat-option>
              </mat-select>
            </mat-form-field>
          </div>
          <div class="col-md-3 pb-2">
            <mat-form-field class="w-100" appearance="outline">
              <mat-label ngRequired>Location</mat-label>
              <ns-multi-select formControlName="locations" [loading]="loadingLocations" panelClass="ns-multi-select-panel small"
                               [selectValuesLabel]="selectLocationsValuesLabel"
                               [disableOptionCentering]=true (closed)="locationsChanged()">
                <mat-option *ngFor="let loc of locations" [value]="loc">{{ loc.locationName }}</mat-option>
              </ns-multi-select>
            </mat-form-field>
            <mat-error [control]="form.controls.locations" ns-error></mat-error>
          </div>
          <div class="col-md-4 pb-2">
            <mat-form-field class="w-100" appearance="outline">
              <mat-label ngRequired>Patterns</mat-label>
              <ns-multi-select formControlName="patterns" [loading]="loadingPatterns" panelClass="ns-multi-select-panel small"
                               [selectValuesLabel]="selectPatternsValuesLabel"
                               [disableOptionCentering]=true (closed)="patternsChanged()" [type]="'group'">
                <mat-optgroup *ngFor="let patternKey of patternKeys" [label]="patternKey.key">
                  <mat-option *ngFor="let pattern of patternKey.values" [value]="pattern">
                    {{ pattern.value }}
                  </mat-option>
                </mat-optgroup>
              </ns-multi-select>
            </mat-form-field>
            <mat-error [control]="form.controls.patterns" ns-error></mat-error>
          </div>
          <div class="col">
            <button [disabled]="loadingLocations || loadingPatterns" mat-stroked-button color="warn" aria-label="Reset" (click)="resetFilters()">
              Reset
            </button>
          </div>
        </div>
      </div>
    </div>
  </form>
</mat-card>
